import { Countries } from '../../../models/countries'

export default {
  [Countries.SE]: [
    {
      caption: 'Kreditansökan företag',
      url: '/static/content/forms/se/2001_BS_Kreditansokan_FTG_intern_utskrift_PRINT.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Kreditansökan privatperson',
      url: '/static/content/forms/se/2007_RM_Kreditansokan_butik_PRIV_SE.PDF',
      extension: 'pdf',
    },
    {
      caption: 'Köpnota',
      url: '/static/content/forms/se/2501_RM_Kopnota_SE_PRINT.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Retur av kreditköp',
      url: '/static/content/forms/se/2501_RM_Retur-av-kreditkop_SE_PRINT.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Extrakort Företag',
      url: '/static/content/forms/se/extracardcorporate.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Extrakort Privat',
      url: '/static/content/forms/se/2007_RM_Ansokan_extrakort_PRIV_PRINT.PDF',
      extension: 'pdf',
    },
    {
      caption: 'Bankfullmakt',
      url: '/static/content/forms/se/bankgrant.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Anmäl konto för utbetalning',
      url: '/static/content/forms/se/1912_MAR_Anmal_konto_utbetalning_ombud_PRINT.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Omläggning av avtal',
      url: '/static/content/forms/se/1901_AC_Omlaggning-avtal_SE_PRINT.pdf',
      extension: 'pdf',
    },
  ],
  [Countries.NO]: [
    {
      caption: 'Retur av kredittkjøp',
      url: '/static/content/forms/no/2501_RM_Retur-av-kreditkop_NO_PRINT.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Kjøpsnota',
      url: '/static/content/forms/no/2501_RM_Kopnota_NO_PRINT.pdf',
      extension: 'pdf',
    },
  ],
  [Countries.FI]: [
    {
      caption: 'Maksutosite',
      url: '/static/content/forms/fi/Maksutosite.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Luotonpalautuslomake',
      url: '/static/content/forms/fi/Luotonpalautuslomake.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Esitietolomake',
      url: '/static/content/forms/fi/Esitietolomake.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Luottohakemus',
      url: '/static/content/forms/fi/Luottohakemus.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Esitietolomake Ruotsiksi',
      url: '/static/content/forms/fi/Esitietolomake_ruotsiksi.pdf',
      extension: 'pdf',
    },
  ],
  [Countries.DK]: [
    {
      caption: 'Købsnota',
      url: '/static/content/forms/dk/2501_RM_Kopnota_DK_PRINT.pdf',
      extension: 'pdf',
    },
    {
      caption: 'Returnering af kreditkøb',
      url: '/static/content/forms/dk/2501_RM_Retur-av-kreditkop_DK_PRINT.pdf',
      extension: 'pdf',
    },
  ],
}
